export const MEMBER_LOGIN = 'MEMBER_LOGIN'
export function memberLogin(mobile, otp, recapchaToken, tierToken) {
  return {
    type: MEMBER_LOGIN,
    mobile,
    otp,
    recapchaToken,
    tierToken,
  }
}

export const MEMBER_LOGIN_SUCCESS = 'MEMBER_LOGIN_SUCCESS'
export function memberLoginSuccess(payload) {
  return {
    type: MEMBER_LOGIN_SUCCESS,
    payload,
  }
}

export const GET_MEMBER_INFO = 'GET_MEMBER_INFO'
export function getMemberInfo() {
  return {
    type: GET_MEMBER_INFO,
  }
}

export const GET_MEMBER_INFO_SUCCESS = 'GET_MEMBER_INFO_SUCCESS'
export function getMemberInfoSuccess(payload) {
  return {
    type: GET_MEMBER_INFO_SUCCESS,
    payload,
  }
}

export const UPDATE_MEMBER_INFO = 'UPDATE_MEMBER_INFO'
export function updateMemberInfo(payload) {
  return {
    type: UPDATE_MEMBER_INFO,
    payload,
  }
}

export const UPDATE_MEMBER_INFO_SUCCESS = 'UPDATE_MEMBER_INFO_SUCCESS'
export function updateMemberInfoSuccess(payload) {
  return {
    type: UPDATE_MEMBER_INFO_SUCCESS,
    payload,
  }
}

export const MEMBER_LOGOUT = 'MEMBER_LOGOUT'
export function memberLogout() {
  return {
    type: MEMBER_LOGOUT,
  }
}
